import { Badge, UserBadge, CreateBadgeRequest, AwardBadgeRequest } from '../Types/badge';
import { transformDateStringPropsToDate } from '../Utils/dateUtils';
import { get, post, httpDelete, getQSFromObject } from './common';

const badgeEndpoint = 'api/badge';

const mapBadge = (item: Badge | null | undefined): Badge | undefined => {
	if (!item) return undefined;
	const mapped = transformDateStringPropsToDate(item, ['CreatedDate', 'ModifiedDate', 'UserAwardedDate']);
	return mapped || undefined;
};

const mapUserBadge = (item: UserBadge | null | undefined): UserBadge | undefined => {
	if (!item) return undefined;
	const mapped = transformDateStringPropsToDate(item, ['AwardedDate']);
	if (mapped && mapped.Badge) {
		mapped.Badge = mapBadge(mapped.Badge);
	}
	return mapped || undefined;
};

const badgeArrayMapper = (items: Badge[]): Badge[] => {
	return items.map(mapBadge).filter((item): item is Badge => item !== undefined);
};

// Badge endpoints
export async function getAllBadges() {
	const endpoint = `${badgeEndpoint}/GetAllBadges`;
	const result = await get<Badge[]>(endpoint);
	return result ? badgeArrayMapper(result) : [];
}

export async function getActiveBadges() {
	const endpoint = `${badgeEndpoint}/GetActiveBadges`;
	const result = await get<Badge[]>(endpoint);
	return result ? badgeArrayMapper(result) : [];
}

export async function getBadge(id: number) {
	const endpoint = `${badgeEndpoint}/GetBadge?${getQSFromObject({ id })}`;
	const result = await get<Badge>(endpoint);
	return result ? mapBadge(result) : undefined;
}

export async function createBadge(badge: CreateBadgeRequest) {
	const endpoint = `${badgeEndpoint}/CreateBadge`;
	const result = await post<Badge>(endpoint, badge);
	return result ? mapBadge(result) : undefined;
}

export async function updateBadge(badge: Badge) {
	const endpoint = `${badgeEndpoint}/UpdateBadge`;
	const result = await post<Badge>(endpoint, badge);
	return result ? mapBadge(result) : undefined;
}

export async function deleteBadge(id: number) {
	const endpoint = `${badgeEndpoint}/DeleteBadge?${getQSFromObject({ id })}`;
	await httpDelete(endpoint);
}

export async function toggleBadgeActive(id: number) {
	const endpoint = `${badgeEndpoint}/ToggleBadgeActive?${getQSFromObject({ id })}`;
	const result = await post<{ success: boolean }>(endpoint, {});
	return result;
}

// UserBadge endpoints

export async function getBadgesWithUserStatus(userId?: number) {
	const endpoint = `${badgeEndpoint}/GetBadgesWithUserStatus?${getQSFromObject({ userId: userId ?? -1 })}`;
	const result = await get<Badge[]>(endpoint);
	return result ? badgeArrayMapper(result) : [];
}

export async function awardBadge(request: AwardBadgeRequest) {
	const endpoint = `${badgeEndpoint}/AwardBadge`;
	const result = await post<UserBadge>(endpoint, request);
	return result ? mapUserBadge(result) : undefined;
}

export async function removeBadge(userBadgeId: number) {
	const endpoint = `${badgeEndpoint}/RemoveBadge?${getQSFromObject({ userBadgeId })}`;
	await httpDelete(endpoint);
}
